import { render, staticRenderFns } from "./ProductsGridIcon.vue?vue&type=template&id=bde1da9c&"
import script from "./ProductsGridIcon.vue?vue&type=script&lang=js&"
export * from "./ProductsGridIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports